<script context="module" lang="ts">
  export var idMap = {};
  export const getId = (name: string) => {
    if (!(name in idMap)) {
      idMap[name] = 0;
    }
    idMap[name] += 1;
    return `${name} ${idMap[name]}`;
  };

  export const defaultTitleSettings: TTitleSettings = {
    type: "h1",
    text: "This is a title",
    weight: "500",
    shadow: false,
    badge: false,
    style: "",
  };
</script>

<script lang="ts">
  import ComponentContainer from "../ComponentContainer/ComponentContainer.svelte";
  import type {
    TComponentContainerSettings,
    TTag,
  } from "../ComponentContainer/types";
  import type { TTitleProps, TTitleSettings } from "./types";

  interface $$Props extends TTitleProps {}

  // Variables
  export let id: string;
  export let tag: TTag = "Title";
  export var settings: Partial<TTitleSettings> | {} = {};
  export let container: Partial<TComponentContainerSettings> | {} = {};

  let _settings = {
    ...defaultTitleSettings,
    ...settings,
  };

  let style = _settings.shadow
    ? (_settings.style += "text-shadow: 0px 0px 8px rgba(0,0,0,0.2);")
    : "";

  _settings.style += `font-weight: ${_settings.weight};`;
  style += _settings.style;
</script>

<ComponentContainer settings={container} {tag} {id}>
  {#if _settings.type == "h1"}
    <h1 class="text" style={_settings.style}>
      {_settings.text}
    </h1>
    {#if _settings.badge}
      <span class="badge">Pro</span>
    {/if}
  {/if}
  {#if _settings.type == "h2"}
    <h2 class="text" style={_settings.style}>
      {_settings.text}
    </h2>
    {#if _settings.badge}
      <span class="badge">Pro</span>
    {/if}
  {/if}
  {#if _settings.type == "h3"}
    <h3 class="text" style={_settings.style}>
      {_settings.text}
    </h3>
    {#if _settings.badge}
      <span class="badge">Pro</span>
    {/if}
  {/if}
  {#if _settings.type == "h4"}
    <h4 class="text" style={_settings.style}>
      {_settings.text}
    </h4>
    {#if _settings.badge}
      <span class="badge">Pro</span>
    {/if}
  {/if}
  {#if _settings.type == "h5"}
    <h5 class="text" style={_settings.style}>
      {_settings.text}
    </h5>
    {#if _settings.badge}
      <span class="badge">Pro</span>
    {/if}
  {/if}
  {#if _settings.type == "h6"}
    <h6 class="text" style={_settings.style}>
      {_settings.text}
    </h6>
    {#if _settings.badge}
      <span class="badge">Pro</span>
    {/if}
  {/if}
</ComponentContainer>

<style>
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    display: inline;
  }
  .badge {
    background-color: var(--sw-brand-color);
    border-radius: var(--sw-badge-radius);
    color: var(--sw-brand-text-color);
    padding: 0.25rem 0.45rem;
    font-weight: 500;
    margin-left: 0.15rem;
    font-size: calc(var(--sw-font-size) * 0.9);
    position: relative;
    display: inline-block;
    transform: translate(0px, -0.2rem) !important;
  }
</style>
